import React, { useMemo } from 'react';
import { Box } from '@mui/material';

interface ColorDotProps {
  color: string;
  size?: number;
}

const ColorDot = React.memo(({ color, size = 9 }: ColorDotProps) => {
  const styles = useMemo(
    () => ({
      display: 'inline-block',
      width: size,
      height: size,
      borderRadius: '50%',
      bgcolor: color,
      border: 0,
      boxShadow: 'none',
      flexShrink: 0,
    }),
    [color, size]
  );

  return <Box component="span" aria-hidden data-color-dot sx={styles} />;
});

export { ColorDot };
